<template>
    <div class="input_bar">
        <div class="input-group input_group" @keyup.enter="emit_login()">
            <!--<input class="input text_input"-->
            <!--type="text"-->
            <!--v-model="login"-->
            <!--placeholder="手机号或邮箱"-->
            <!--@keyup.enter="emit_login()">-->
            <el-input :placeholder="use_phone?'请输入手机号':'请输入邮箱'" v-model="login"></el-input>
        </div>
        <div v-if="use_password" class="input-group input_group" @keyup.enter="emit_login()">
            <!--<input class="input text_input" style="border:none;"-->
            <!--type="password"-->
            <!--v-model="password"-->
            <!--placeholder="密码"-->
            <!--@keyup.enter="emit_login()">-->
            <el-input placeholder="请输入密码" v-model="password" show-password></el-input>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            use_phone: {
                type: Boolean,
                require: true
            },
             use_password: {
                type: Boolean,
                default: true,
                require: true
            }
        },
        data() {
            return {
                login: '',
                password: ''
            }
        },
        computed: {
            sign_on_info: function () {
                return {
                    'login': this.login,
                    'password': this.password
                }
            }
        },

        watch: {
            sign_on_info(info) {
                this.$emit('signOnInfo', info)
            }
        },

        methods: {
            emit_login: function () {
                this.$emit('emit_login')
            }
        }
    }
</script>

<style type="text/css" scoped>
    >>> .el-input__inner {
        border: none;
    }

    .input {
        border: none;
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border-radius: .25rem;
    }

    .input:focus {
        color: #495057;
        background-color: #fff;
        border-color: #4ff8cd;
        outline: 0;
        box-shadow: 0 0 0 .2rem rgba(8, 191, 145, .25)
    }

    .input_group {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;
    }

    .input_icon {
        font-size: 14px;
        padding: 6px 12px;
        color: #555;
        text-align: center;
        background: #eee;
        border: 1px solid #ccc;
        border-radius: 4px;
        border-right: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .text_input {
        font-size: 14px;
    }

    .text_input::placeholder {
        color: #c6c6c6;
    }

    .text_input:focus {
        box-shadow: none;
        border-color: #66CCFF;
    }

</style>
